<template>
  <div class="d-flex">
    <button
      v-if="prevStep"
      type="button"
      class="btn btn-secondary m-1"
      @click.prevent="back"
    >
      &lt; Back
    </button>

    <button
      v-if="nextStep"
      type="button"
      :disabled="disableNextBtn"
      class="btn btn-primary m-1"
      @click.prevent="next"
    >
      {{ nextStepLabel ? `Next Select ${nextStepLabel}` : "Next" }} &gt;
    </button>
  </div>
</template>
<script>
import { OrderSteps, OrderLabels } from "@/types/orderSteps.js";
import { mapGetters } from "vuex";

export default {
  props: {
    disableNextBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      service: "service/service",
      orderName: "order/name",
      orderInstruction: "order/instruction",
      images: "order/images",
    }),

    nextStepLabel() {
      return OrderLabels[this.nextStep] ?? null;
    },

    nextStep() {
      const steps = {
        [OrderSteps.StepOne]: OrderSteps.StepTwo,
        [OrderSteps.StepTwo]: OrderSteps.StepThree,
        [OrderSteps.StepThree]: OrderSteps.StepFour,
      };
      return steps[this.$route.name] ?? null;
    },
    prevStep() {
      const steps = {
        [OrderSteps.StepFour]: OrderSteps.StepThree,
        [OrderSteps.StepThree]: OrderSteps.StepTwo,
        [OrderSteps.StepTwo]: OrderSteps.StepOne,
      };

      return steps[this.$route.name] ?? null;
    },
  },

  methods: {
    next() {
      this.$emit("next");
    },
    back() {
      if (this.prevStep) {
        this.$router.push({
          name: this.prevStep,
          params: { slug: this.service.slug },
          query: { ...this.$route.query },
        });
      }
    },
  },
};
</script>
